import { get, post } from './http-calls';

export const getVHCItem_Dropdown = async () => {
    let res = await get(`VHCItems/VHCItem_Dropdown`, { useAuthToken: true });
    return res;
};

export const getVHCItems = async ({ companyId, startDate, endDate, vhcValueId }) => {
    const query =
        `VHCItems/VHCItem_List?Company=${companyId}` +
        `&StartDate=${startDate}` +
        `&EndDate=${endDate}` +
        (vhcValueId ? `&VHCValueSelected=${vhcValueId}` : '');

    const res = await get(query, { useAuthToken: true });
    return res;
};
